import { render, staticRenderFns } from "./PatentCategory.vue?vue&type=template&id=61ac2b3e"
import script from "./PatentCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentCategory.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports